import { AddressCreateDirectiveModule } from '@b2b/common/directives/address/create/create.directive';
import { ApiService } from '@b2b/common/services/api/types';
import { TODO } from '@b2b/types/core/utils';
import angular, { IScope } from 'angular';

CreateEditAddressModalController.$inject = [
  '$scope',
  '$uibModalInstance',
  'ApiService',
  'ValidateService',
  'address',
  'organizationId',
  'preventSave',
];

function CreateEditAddressModalController(
  $scope: IScope & { createEditAddressModal: TODO },
  $uibModalInstance: TODO,
  ApiService: ApiService,
  ValidateService: TODO,
  address: TODO,
  organizationId: TODO,
  preventSave: TODO
) {
  const ctrl = {
    title: 'Add Address',

    errors: [],

    model: {},

    createAddress: false,
    address: false,

    preventSave: false,

    organizationId: '',

    init: function () {
      if (address) {
        ctrl.title = 'Edit Address';
        ctrl.model = address;
      }

      if (organizationId) {
        ctrl.organizationId = organizationId;
      }

      if (preventSave) {
        ctrl.preventSave = preventSave;
      }

      $scope.$on('AddressList::Create', ctrl.onAddressListCreate);
      $scope.$on('AddressCreate::Complete', ctrl.onAddressCreateComplete);
    },

    getAddress: function () {
      ApiService.organizations.contacts
        .detail({
          organizationId: organizationId,
          // contactId: contact.id, // TODO: is this still needed?
        })
        .then(ctrl.success.getAddress, ctrl.error.getAddress);
    },

    done: function () {
      $scope.$broadcast('AddressCreate::Process');
    },

    cancel: function () {
      $uibModalInstance.dismiss('cancel');
    },

    success: {
      getAddress: function (response) {
        // noop
      },
    },

    error: {
      getAddress: function (response) {
        // noop
      },
    },

    onAddressListCreate: function (e, data) {
      ctrl.createAddress = true;
    },

    onAddressCreateComplete: function (e, data) {
      $uibModalInstance.close(data.address);
    },
  };

  $scope.createEditAddressModal = ctrl;
  ctrl.init();
}

export const PartnersCreateCreateEditAddressModalControllerModule = angular
  .module('acme.view.application.partners.create.createEditAddressModal.controllers', [
    'acme.common.service.api',
    'acme.common.service.validate',
    AddressCreateDirectiveModule,
  ])
  .controller('CreateEditAddressModalController', CreateEditAddressModalController).name;
